/** The "Shared with team" / "Shared with 2 people" pill on a shared deal. */
import { Users } from "lucide-react";
import React from "react";

interface SharedBadgeProps {
	/** From `shareBadgeLabel`. */
	label?: string;
}

const SharedBadge: React.FC<SharedBadgeProps> = ({
	label = "Shared with team",
}) => (
	<span className="inline-flex h-[22px] flex-shrink-0 items-center gap-1 rounded-full bg-[#E6F3F3] px-2 text-[11.5px] font-semibold text-[#004C4B]">
		<Users className="h-3 w-3" aria-hidden />
		{label}
	</span>
);

export default SharedBadge;
